<template>
    <a-row :gutter="24">
      <a-col :md="24">
        <a-card :style="cardStyle1" :bordered="false">
          <!-- 查询区域 -->
          <div class="table-page-search-wrapper">
            <!-- 搜索区域 -->
            <a-form layout="inline" @keyup.enter.native="searchQuery">
              <a-row :gutter="24">
                <a-col :md="8" :lg="6"  :sm="24">
                  <a-form-item label="物流中心" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input placeholder="请输入物流中心" v-model="topQueryParam.logistics"></a-input>
                  </a-form-item>
                </a-col>
                <a-col :md="8" :lg="6"  :sm="24">
                  <a-form-item label="申请人" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input placeholder="请输入申请人" v-model="topQueryParam.applicant"></a-input>
                  </a-form-item>
                </a-col>
                <a-col :md="8" :lg="6"  :sm="24">
                  <a-form-item label="仓库" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input placeholder="请输入仓库" v-model="topQueryParam.warehouse"></a-input>
                  </a-form-item>
                </a-col>
                <a-col :md="8" :lg="6"  :sm="24">
                  <a-form-item label="货位" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input placeholder="请输入货位" v-model="topQueryParam.location"></a-input>
                  </a-form-item>
                </a-col>
                <a-col :md="8" :lg="6"  :sm="24">
                  <a-form-item label="制单人" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input placeholder="请输入制单人" v-model="topQueryParam.preparedBy"></a-input>
                  </a-form-item>
                </a-col>
                <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                  <a-col :md="8" :lg="6"  :sm="24">
                    <a-button type="primary" @click="searchQuery">查询</a-button>
                    <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>
                  </a-col>
                </span>
              </a-row>
            </a-form>
          </div>
          <!-- 操作按钮区域 -->
          <div class="table-operator" style="margin-top: 5px">
            <a-button @click="handleAdd" type="primary" icon="plus">添加</a-button>
          </div>
          <!-- table区域-begin -->
          <div>
            <a-table ref="table" size="middle" bordered
              :rowKey="(record,index)=>{return index}" :columns="columns"
              :dataSource="dataSource" :components="handleDrag(columns)"
              :pagination="ipagination"  :scroll="{ x: true }"  :loading="loading"
              :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange,columnWidth:'50px'}"
               @change="handleTableChange">
              <span slot="action" slot-scope="text, record">
                <a-popconfirm title="是否通过审批?" ok-text="通过" cancel-text="不通过" @confirm="() => handleAudit(record,1)" @cancel="() => handleAuditCancel(record,2)">
                  <a v-if="record.state === 1 || record.state === 2" disabled type="primary">审批</a>
                  <a v-else type="primary">审批</a>
                </a-popconfirm>
                <a-divider type="vertical" />
                <a type="primary" @click="delConfirm(handleDelete,record)">删除</a>
              </span>
              <template slot="createTime" slot-scope="createTime">
                <span>{{changetime(createTime)}}</span>
              </template>

              <template slot="state" slot-scope="state">
                <a-tag color="blue" v-if="state === 0">审核中</a-tag>
                <a-tag color="green" v-else-if="state === 1">审核通过</a-tag>
                <a-tag color="red" v-else-if="state === 2">未通过审核</a-tag>
              </template>

              <template slot="attachment" slot-scope="attachment">
                <a-popover placement="right" trigger="click">
                  <template slot="content">
                    <img :src="getImgUrl(attachment, '')" width="500px" />
                  </template>
                  <div style="width:52px;height:52px;" v-if="attachment">
                    <img  :src="getImgUrl(attachment, '')" class="item-img" title="查看大图" style="width:100%;height:auto"/>
                  </div>
                </a-popover>
              </template>

            </a-table>
          </div>
          <!-- table区域-end -->
          <!-- 表单区域 -->
          <InspectionModal ref="modalForm" @ok="modalFormOk" @close="modalFormClose"></InspectionModal>
        </a-card>
      </a-col>
    </a-row>
  </template>
  <!-- create ji sheng hua-->
  <script>
  import InspectionModal from './modules/InspectionModal'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { BillListMixin } from './mixins/BillListMixin'
  import { inspectionDelete,inspectionEdit } from '@/api/api'
  import JEllipsis from '@/components/jeecg/JEllipsis'
  import JDate from '@/components/jeecg/JDate'
  import { getFileAccessHttpUrl } from '@api/manage'

  export default {
    name: 'RetailOutList',
    mixins: [JeecgListMixin, BillListMixin],
    components: {
      InspectionModal,
      JEllipsis,
      JDate,
    },
    data() {
      return {
        ipagination: {
          pageSizeOptions: ['10', '20', '30', '100', '200'],
        },
        // 查询条件
        topQueryParam: {
          page: 1,
          limit: 20,
          keywords: '',
          specification: '',
          codeSystem:''
        },
        prefixNo: 'LSCK',
        labelCol: {
          span: 5,
        },
        wrapperCol: {
          span: 18,
          offset: 1,
        },
        specList: [
          {
            // 包装规格
            label: 'A公司',
            value: '0',
          },
          {
            label: 'B公司',
            value: '1',
          }
        ],
        matype: [
          {
            label: '待审核',
            value: '1',
          },
          {
            label: '审核通过',
            value: '2',
          }
        ], // 包装规格
        // 默认列
        columns: [
          { title: '单据编号', dataIndex: 'code', width: 80, render: (text) => text || "--"},
          { title: '单据日期', dataIndex: 'date', width: 120, render: (text) => text || "--"},//scopedSlots: { customRender: 'specCodeSystem' }
          { title: '申请部门', dataIndex: 'department', width: 150,render: (text) => text || "--" },
          { title: '物流中心', dataIndex: 'logistics', width: 150,render: (text) => text || "--"}, // ellipsis: true
          { title: '申请人', dataIndex: 'applicant', width: 100, render: (text) => text || "--" },
          { title: '仓库', dataIndex: 'warehouse', width: 150,render: (text) => text || "--" },
          { title: '转移至货位', dataIndex: 'location', width: 120,render: (text) => text || "--" },
          { title: '制单人', dataIndex: 'preparedBy', width: 100,render: (text) => text || "--" },
          { title: '制单时间', dataIndex: 'preparedTime', width: 100,render: (text) => text || "--" },
          { title: '创建人', dataIndex: 'createBy', width: 100,render: (text) => text || "--" },
          { title: '创建时间', dataIndex: 'createTime', width: 100,render: (text) => text || "--" },
          { title: '单据状态', dataIndex: 'state', width: 100, scopedSlots: { customRender: 'state' },render: (text) => text || "--" },
          { title: '附件', dataIndex: 'attachment', scopedSlots: { customRender: 'attachment' },width: 180,render: (text) => text || "--" },
          {
            title: '操作',
            dataIndex: 'action',
            align: 'center',
            width: 180,
            fixed: 'right',
            scopedSlots: { customRender: 'action' },
          },
        ],
        url: {
          list: '/quality/samplingInspection/list',
        },
      }
    },
    computed: {},
    created() {
      // this.initSystemConfig()
      this.initRetail()
      this.getDepotData()
      this.initUser()
      this.initAccount()
    },
    methods: {
      getImgUrl (imgName, type) {
        if (imgName && imgName.split(',')) {
          type = type ? type + '/' : ''
          return getFileAccessHttpUrl('systemConfig/static/' + type + imgName.split(',')[0])
        } else {
          return ''
        }
      },

      changetime(createTime) {
        return createTime.replace('T', ' ')
      },
      async handleAudit(record,e) {
        console.log(record,'审核record============')
        let params = {
          id : record.id,
          state: e
        }
        const res = await inspectionEdit(params)
        this.loadData()
      },
      //handleAuditCancel
      async handleAuditCancel(record,e) {
        console.log(record,'审核record============')
        let params = {
          id : record.id,
          state: e
        }
        const res = await inspectionEdit(params)
        this.loadData()
      },

      //删除handleDelete
      async handleDelete(record) {
        let params = {
          id : record.id
        }
        const res = await inspectionDelete(params)
        if (res.code == 200 && res.success == true) {
          this.$message.success(res.message)
          this.loadData()
        } else {
          this.$message.error(res.message)
        }

      },
    },
  }
  </script>
  <style scoped>
  @import '~@assets/less/common.less';
  /deep/.ant-table-row-cell-break-word:empty:after {
    content: '--';
  }
  </style>